module.exports = __webpack_public_path__ + "static/media/CM-marca_sobre-verde-RGB.e84e07b0.svg";